import { postJson } from "Shared/server";
import { updateAppShellData } from "./../AppShell/action-creators";
import { nuke } from "SiteLayout/CurrentPage/cache";
import { updateUserNameOnImbox, login as gtmLogin, updateODPTrackingLogin, } from "../TrackingInformation";
import { pushState, replaceState } from "Shared/history";
export const SET_NEW_IMPERSONATION = "SET_NEW_IMPERSONATION";
export function setNewImpersonation() {
    return (dispatch, getState) => {
        nuke();
        dispatch({
            type: SET_NEW_IMPERSONATION,
        });
    };
}
export function login(details) {
    return (dispatch, getState) => {
        let redirectUrl = getState().accountBox.redirectToAfterLogin.href;
        return new Promise((resolve, reject) => {
            postJson("/login", details)
                .then((result) => {
                if (result.success) {
                    gtmLogin("Username/Password", details.customerId);
                    if (result.shouldBeRedirected) {
                        redirectUrl = result.redirectUrl;
                    }
                    return Promise.resolve(result);
                }
                return Promise.reject(result);
            })
                .then(() => nuke())
                .then(() => {
                dispatch(updateAppShellData())
                    .then(() => resolve())
                    .then(() => !!redirectUrl ? pushState(redirectUrl) : replaceState());
            })
                .catch(reject);
        }).then(() => {
            const currentUser = getState().currentUser;
            updateUserNameOnImbox(currentUser);
            updateODPTrackingLogin(currentUser.customerId, currentUser.email);
        });
    };
}
export function logout() {
    return (dispatch, getState) => {
        let redirecUrl = "/";
        let logoutFrom = "";
        return postJson("/Logout/OktaLogout")
            .then((r) => {
            if (r.logoutFrom === "impersonationPage") {
                redirecUrl = r.redirectUrl;
                logoutFrom = r.logoutFrom;
            }
            if (r.logoutFrom === "supplierPage") {
                redirecUrl = r.redirectUrl;
                logoutFrom = r.logoutFrom;
            }
            return Promise.resolve();
        })
            .then(() => pushState(redirecUrl))
            .then(() => {
            if (logoutFrom === "" || logoutFrom === "impersonationPage") {
                dispatch(setNewImpersonation());
                return dispatch(updateAppShellData());
            }
            else {
                nuke();
                return Promise.resolve();
            }
        })
            .then(() => {
            let currentUser = getState().currentUser;
            updateUserNameOnImbox(currentUser);
        });
    };
}
export function register(email, password) {
    return (dispatch) => {
        return postJson("/register", { email, password }).then((result) => {
            return Promise.resolve(result);
        });
    };
}
export function searchUsers(query) {
    return (dispatch) => {
        return postJson("/SearchContactApi/Search", query).then((resp) => {
            return resp;
        });
    };
}
